/**
 *
 *
 * @prettier
 * @author Brook Worku
 * @since
 *
 * This table is to display FFPS User First Name, Last Name and Email
 */

import React from 'react'
import { UserInformation } from '../../settings/types/FfpsUserDetailsTypes'

const FfpsUserInfoTable = ({ ffpsUserFirstName, ffpsUserLastName, ffpsUserEmail }: UserInformation) => {
  return (
    <table>
      <thead>
        <tr>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{ffpsUserFirstName}</td>
          <td>{ffpsUserLastName}</td>
          <td>{ffpsUserEmail}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default FfpsUserInfoTable
